<template>
    <b-navbar id="nav-header" toggleable="lg" type="light" variant="white" class="justify-content-center"> 

        <b-navbar-brand :href="publicWebURI" class="d-flex justify-content-center">
            <img src="../assets/Superasy-SoloLogo.webp" alt="Logo" height="30" class="logo d-inline-block align-top" />
        </b-navbar-brand>

        <template v-if="displayTopLinks">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item href="/">Inicio</b-nav-item>
                    <b-nav-item href="/about-us">Acerca de</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </template>
    </b-navbar>
</template>

<script>
import {publicWebURI} from '@/apiConfig'
export default {
    name: "navHeader",
    props: {
        displayTopLinks: {
            type: Boolean,
            default: false
        },
        publicWebURI: {
            type: String,
            default: () => publicWebURI
        }
    }
};
</script>

<style lang="scss">
#nav-header {
    $margin: 0.25em;
    .logo {
        transform: scale(2.25) translateY(0.5em);
        margin-left: $margin;
        margin-right: $margin;
    }
}
</style>